import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import MainLayout from './layouts/MainLayout';
import AdminLayout from './layouts/AdminLayout';
import AuthCallback from './pages/AuthCallback';
import { Toaster } from 'react-hot-toast';
import ErrorBoundary from './components/ErrorBoundary';
import NotFound from './pages/NotFound';
import SkipLink from './components/SkipLink';

function App() {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <Router>
          <SkipLink />
          <Routes>
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/admin/*" element={<AdminLayout />} />
            <Route path="/*" element={<MainLayout />} />
          </Routes>
          <Toaster 
            position="top-right"
            toastOptions={{
              duration: 4000,
              className: 'bg-white shadow-lg rounded-lg p-4',
              success: {
                className: 'bg-green-50 border border-green-100',
                iconTheme: {
                  primary: '#10B981',
                  secondary: '#ffffff',
                },
              },
              error: {
                className: 'bg-red-50 border border-red-100',
                iconTheme: {
                  primary: '#EF4444',
                  secondary: '#ffffff',
                },
              },
            }} 
          />
        </Router>
      </HelmetProvider>
    </ErrorBoundary>
  );
}

export default App;